function countdown(container, endDate) {
    let days, hours, minutes, seconds;

    endDate = new Date(endDate).getTime();

    if (isNaN(endDate)) return;

    setInterval(calculate, 1000);

    function calculate() {
        let startDate = new Date().getTime();
        let timeRemaining = parseInt((endDate - startDate) / 1000);

        if (timeRemaining >= 0) {
            days = parseInt(timeRemaining / 86400);
            timeRemaining = timeRemaining % 86400;

            hours = parseInt(timeRemaining / 3600);
            timeRemaining = timeRemaining % 3600;

            minutes = parseInt(timeRemaining / 60);
            seconds = timeRemaining % 60;

            const daysElem = container.querySelector(".days");
            const hoursElem = container.querySelector(".hours");
            const minutesElem = container.querySelector(".minutes");
            const secondsElem = container.querySelector(".seconds");

            if (daysElem) daysElem.innerHTML = parseInt(days, 10);
            if (hoursElem) hoursElem.innerHTML = ("0" + hours).slice(-2);
            if (minutesElem) minutesElem.innerHTML = ("0" + minutes).slice(-2);
            if (secondsElem) secondsElem.innerHTML = ("0" + seconds).slice(-2);
        }
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const timerContainers = document.querySelectorAll(".timer-container");
    timerContainers.forEach((container) => {
        const endDate = container.getAttribute("data-end-date");
        countdown(container, endDate);
    });
});

